export enum SPACES {
	XL = 'xl',
	LG = 'lg',
	MD = 'md',
	SM = 'sm',
	XS = 'xs',
}

export type Space = `${SPACES}`;

export enum FONT_WEIGHT {
	EXTRALIGHT = 'extralight',
	LIGHT = 'light',
	DEMI = 'demi',
	REGULAR = 'regular',
	MEDIUM = 'medium',
	DEMIBOLD = 'demibold',
	BOLD = 'bold',
	EXTRABOLD = 'extrabold',
	BLACK = 'black',
}

export type FontWeight = `${FONT_WEIGHT}`;

export enum TEXT_COLOR {
	TEXT1 = 'text1',
	TEXT2 = 'text2',
	TEXT3 = 'text3',
	TEXT4 = 'text4',
	TEXT5 = 'text5',
	TEXT6 = 'text6',
	TEXT23 = 'text23',
}
export type TextColor = `${TEXT_COLOR}`;

export enum TEXT_ALIGN {
	CENTER = 'center',
	LEFT = 'left',
	RIGHT = 'right',
}

export type TextAlign = `${TEXT_ALIGN}`;
